import { SlateFragmentHandler } from './handlers/SlateFragmentHandler';
import { HtmlContentHandler } from './handlers/HtmlContentHandler';
import { PlainTextHandler } from './handlers/PlainTextHandler';
import { MIMETypeName } from '@plone/volto-slate/utils/mime-types';

/**
 * Manages data transfer operations for the Slate editor
 * Coordinates different content type handlers following SRP
 */
export class DataTransferManager {
  constructor(editor) {
    this.editor = editor;
    this.handlers = new Map([
      ['application/x-slate-fragment', new SlateFragmentHandler(editor)],
      ['text/html', new HtmlContentHandler(editor)],
      ['text/plain', new PlainTextHandler(editor)],
    ]);
  }

  getHandlers() {
    const handlers = {};
    for (const [type, handler] of this.handlers) {
      handlers[type] = async (data, fullMime) =>
        await handler.handle(data, fullMime);
    }
    return handlers;
  }

  async handleData(data) {
    for (let i = 0; i < this.editor.dataTransferFormatsOrder.length; ++i) {
      const dt = this.editor.dataTransferFormatsOrder[i];

      if (dt === 'files') {
        const { files } = data;
        if (files && files.length > 0) {
          return this.editor.dataTransferHandlers['files'](files);
        }
        continue;
      }

      const satisfyingFormats = data.types.filter((y) =>
        new MIMETypeName(dt).matches(new MIMETypeName(y)),
      );

      for (let j = 0; j < satisfyingFormats.length; ++j) {
        const y = satisfyingFormats[j];
        const result = await this.editor.dataTransferHandlers[dt](
          data.getData(y),
          y,
        );
        if (result) {
          return true;
        }
      }
    }
    return false;
  }
}
